import React from "react";
import { BotaoMenor } from "../../StyledComponent";
import { Link } from "react-router-dom";
import FacebookIcon from "../../../assets/facebook_federation.png";
import InstagramIcon from "../../../assets/instagram_social.png";
import YouTubeIcon from "../../../assets/youtube_social.png";
import Fade from "@material-ui/core/Fade";

import "./styles.scss";

const MsgSucessoTrocaSenha = () => {
  return (
    <Fade in>
      <div className="loginForm loginForgotPassword">
        <div className="forgot-password centralized-column">
          <h1>Nova senha:</h1>
          <p>A senha foi altera com sucesso.</p>
          <BotaoMenor backgroundcolor="#003da5" id="btnBackToLogin">
            <Link to="/">LOGIN</Link>
          </BotaoMenor>
        </div>
        <div className="msgSocialMedia centralized-column">
          <p className="msgSocialMedia__msg">
            Não se esqueça de nos seguir na sua rede social favorita para obter
            atualizações importantes, dicas e mais!
          </p>
          <div className="msgSocialMedia__socialMedia centralized-space-evenly">
            <img src={FacebookIcon} alt="Facebook" />
            <img src={InstagramIcon} alt="Instagram" />
            <img src={YouTubeIcon} alt="Facebook" />
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default MsgSucessoTrocaSenha;
